<script setup lang="ts">
  // import SidebarLink from '~/components/UI/Utilities/SidebarLink.vue';
  // import SidebarSection from '~/components/UI/Utilities/SidebarSection.vue';
  import { Role } from '~/types/auth';
  // import { ChevronRightIcon } from '@heroicons/vue/solid';
  import AppSidebar from '~/components/Dashboard/Others/AppSidebar.vue';

  const { isExpenseEnabled } = useAuth();
  // const userRoles = computed(() => role.value);
  const route = useRoute();
  const activeCategory = ref<string | null>(null);
  // const isUtilitiesOnly = computed(() => userRoles.value.length === 1 && userRoles.value[0] === Role.UtilitiesAccess);
  const sidebarOpen = ref(false);

  const handleSidebarState = (val: boolean) => {
    sidebarOpen.value = val;
  };

  const emit = defineEmits(['sidebar-state']);

  watch(sidebarOpen, val => {
    emit('sidebar-state', val);
  });

  // const setActiveCategory = (title: string) => {
  //   activeCategory.value = activeCategory.value === title ? null : title;
  // };

  // const hasRole = (allowedRoles: string[]) => {
  //   if (allowedRoles.includes('all')) {
  //     return true;
  //   }
  //   return userRoles.value.some(userRole => allowedRoles.includes(userRole));
  // };

  const reportCategories = [
    {
      title: 'Donation',
      links: [
        {
          to: '/donation-report',
          label: 'Donation Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.DonorReportManager]
        }
      ]
    },
    {
      title: 'Donor',
      links: [
        {
          to: '/donor-report',
          label: 'Donor Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.DonorReportManager]
        }
      ]
    },
    {
      title: 'Grants',
      links: [
        {
          to: '/user-vs-grants',
          label: 'User vs Grants',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.GrantReportManager]
        },
        {
          to: '/grant-utilization-report',
          label: 'Grant Utilization Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.GrantReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/fund-balance-report',
          label: 'Fund Balance Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.GrantReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/all-grants-data-export',
          label: 'All Grants Data Export',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.GrantReportManager, Role.DonorAuditor]
        },
        {
          to: '/grant-monthly-balance-report',
          label: 'Grant Monthly Balance Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.GrantReportManager, Role.DonorAuditor],
          requiresExpense: isExpenseEnabled
        }
      ]
    },
    {
      title: 'Budget',
      links: [
        {
          to: '/all-budget-data-export',
          label: 'All Budget Data Export',
          roles: [Role.Admin, Role.BudgetAdmin, Role.OrgReportManager, Role.ReadOnly, Role.BudgetReportManager],
          requiresExpense: isExpenseEnabled
        }
      ]
    },
    {
      title: 'Payee',
      links: [
        {
          to: '/payee-report',
          label: 'Payee Report',
          roles: [Role.Admin, Role.PayeeAdmin, Role.ReadOnly, Role.ExpenseReportManager],
          requiresExpense: isExpenseEnabled
        }
      ]
    },
    {
      title: 'Expense',
      links: [
        {
          to: '/expenses-report',
          label: 'Expenses Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.ExpenseReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/payment-report',
          label: 'Payment Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.ExpenseReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/expense-attachment-report',
          label: 'Expense Attachment Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.ExpenseReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/payee-expense-report',
          label: 'Payee Expense Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.ExpenseReportManager],
          requiresExpense: isExpenseEnabled
        },
        {
          to: '/advance-payment-report',
          label: 'Advance Payment Report',
          roles: [Role.Admin, Role.OrgReportManager, Role.ReadOnly, Role.ExpenseReportManager, Role.AdvanceAdmin],
          requiresExpense: isExpenseEnabled
        }
      ]
    }
  ];

  watch(
    () => route.path,
    () => {
      const match = reportCategories.find(category => category.links.some(link => link.to === route.path));
      if (match) activeCategory.value = match.title;
    },
    { immediate: true }
  );
</script>

<template>
  <div class="flex w-full h-[calc(100vh-56px)]">
    <AppSidebar @sidebar-state="handleSidebarState" />

    <div
      class="transition-all duration-300"
      :class="sidebarOpen ? 'w-[calc(100%-60px)] ml-[60px] h-full' : 'w-[calc(100%-60px)] ml-[60px]  h-full'"
    >
      <slot />
    </div>
  </div>
</template>
<style scoped>
  .accordion-enter-active,
  .accordion-leave-active {
    transition:
      max-height 0.35s ease,
      opacity 0.25s ease,
      transform 0.25s ease;
  }

  .accordion-enter-from {
    max-height: 0;
    opacity: 0;
    transform: translateY(-4px);
  }

  .accordion-enter-to {
    max-height: 500px; /* enough for links */
    opacity: 1;
    transform: translateY(0);
  }

  .accordion-leave-from {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }

  .accordion-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-4px);
  }
</style>
